define(
    // 利用先の都道府県の中心付近のタイルを一つ選んで入れること
    [ // レベル9-11のタイル1つを表すURL群
        '/11/1767/826.png'
    ]
);